import { GET_SAVED_EARNINGS_CODES, } from "../../types";

const initialState = {};
const savedEarningsCodes = (state = initialState, action) => {
  switch (action.type) {
    case GET_SAVED_EARNINGS_CODES: {
      return action.payload;
    }
    default:
      return state;
  }
};
export default savedEarningsCodes;